export const API_BASE = import.meta.env.VITE_API_URL || 'https://fortino.gulumahotel.com'

function getToken() {
  return localStorage.getItem('ft_token')
}

async function request(path, options = {}) {
  const headers = { ...(options.headers || {}) }
  const token = getToken()
  if (token) headers.Authorization = `Bearer ${token}`
  if (!(options.body instanceof FormData) && !headers['Content-Type']) {
    headers['Content-Type'] = 'application/json'
  }

  const res = await fetch(`${API_BASE}/api${path}`, {
    credentials: 'include',
    ...options,
    headers,
  })

  const data = await res.json().catch(() => ({}))
  if (!res.ok) {
    const error = new Error(data.message || `Request failed: ${res.status}`)
    error.response = { data, status: res.status }
    throw error
  }
  return { data, status: res.status }
}

export const api = {
  get: (url) => request(url),
  post: (url, body) => request(url, {
    method: 'POST',
    body: body instanceof FormData ? body : JSON.stringify(body || {}),
  }),
  put: (url, body) => request(url, {
    method: 'PUT',
    body: body instanceof FormData ? body : JSON.stringify(body || {}),
  }),
  delete: (url) => request(url, { method: 'DELETE' }),
}

export function mediaUrl(path) {
  if (!path) return ''
  if (path.startsWith('http://') || path.startsWith('https://') || path.startsWith('blob:') || path.startsWith('data:')) {
    return path
  }
  return `${API_BASE}${path.startsWith('/') ? path : `/${path}`}`
}

export async function fetchList(url) {
  const { data } = await api.get(url)
  return data.data || []
}
